import { Row } from './custom';

export default function Footer()
{
    return (
        <Row id='footer'>
            <span>Copyright © 2025 | Q2LENS | All Rights Reserved</span>
        </Row>
    );
}